import './contact-modal.scss';

const SELECTORS = {
  MODAL: '#modalContact',
  FORM_WRAPPER: '#contact-state-form',
  ERROR: '#contact-state-error',
  RETRY_BTN: '#contact-btn-retry',
};

/**
 * version    1.0
 * class      ContactModal
 * classdesc  Component that manages the contact modal form states
 */
export class ContactModal {
  constructor() {
    this._findUIElements();
    if (!this._els.modal.length) return;
    this._bindEvents();
  }

  _findUIElements() {
    this._els = {
      modal: $(SELECTORS.MODAL),
      formWrapper: $(SELECTORS.FORM_WRAPPER),
      error: $(SELECTORS.ERROR),
      retryBtn: $(SELECTORS.RETRY_BTN),
    };
  }

  _bindEvents() {
    this._els.retryBtn.on('click', (e) => {
      e.preventDefault();
      this._els.error.addClass('d-none');
      this._els.formWrapper.removeClass('d-none');
    });
  }
}
